import { useState, useEffect, useRef } from "react";
import { Button, ButtonGroup, Row, Col, Form, Modal } from "react-bootstrap";
import { IntlProvider, FormattedMessage } from "react-intl";
import enMessages from "./locales/en.json";
import arMessages from "./locales/ar.json";
import SectionSeparator from "./components/SectionSeparator";
import SubSectionSeparator from "./components/SubSectionSeparator";
import { ToastContainer, toast } from "react-toastify";
import FilePicker from "./components/FilePicker";
import DocumentUploadBlock from "./components/DocumentUploadBlock";
// import AdmissionCountries from "./components/AdmissionCountries";
// import AdmissionSiblings from "./components/AdmissionSiblings";
// import QASection from "./components/QASection";
import DatePicker from "react-datepicker";
// import { FiPlus, FiMinus } from "react-icons/fi";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";
import { FiPlus, FiMinus } from "react-icons/fi";
// import CenterDropdown from "./components/CenterDropdown";
var Chance = require("chance");
var chance = new Chance();

const App = () => {
  // Get query parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");

  // Refs
  const recaptcha = useRef();

  // Constants
  const version = "2.3";
  const API_URL = process.env.REACT_APP_API_URL;
  const STORAGE_URL = process.env.REACT_APP_PORTAL_URL;
  const messages = {
    en: enMessages,
    ar: arMessages,
  };
  const steps = [
    { name: "step.student_details", step: 1 },
    { name: "step.required_documents", step: 2 },
    { name: "step.clinic_information", step: 3 },
  ];
  const DOCUMENT_TYPES = {
    father: [
      { value: "father_passport", label: "Father Passport" },
      { value: "father_visa", label: "Father Visa" },
      { value: "father_id_1", label: "Father ID Front" },
      { value: "father_id_2", label: "Father ID Back" },
    ],
    mother: [
      { value: "mother_passport", label: "Mother Passport" },
      { value: "mother_visa", label: "Mother Visa" },
      { value: "mother_id_1", label: "Mother ID Front" },
      { value: "mother_id_2", label: "Mother ID Back" },
    ],
    child: [
      { value: "child_passport", label: "Child Passport" },
      { value: "child_visa", label: "Child Visa" },
      { value: "child_id_1", label: "Child ID Front" },
      { value: "child_id_2", label: "Child ID Back" },
      { value: "child_birth_certificate", label: "Birth Certificate" },
      { value: "child_vaccination", label: "Vaccination Card" },
      { value: "child_medical_insurance", label: "Medical Insurance" },
      { value: "child_indemnity", label: "Indemnity Form" },
    ],
    other: [{ value: "other", label: "Other Document" }],
  };

  const chronicIllnesses = [
    "Diabetes Mellitus",
    "Hypertension",
    "Chronic respiratory diseases such as Asthma",
    "Cardiac Disease",
    "Kidney Disease",
    "Liver Disease",
    "Autoimmune Disease",
    "Hematological Disorders",
    "Other",
  ];
  const illnesses = [
    "Chicken Pox",
    "Diphtheria",
    "Infective Hepatitis",
    "Measles",
    "Meningitis",
    "Mumps",
    "Poliomyelitis",
    "Pneumonia",
    "Rheumatic Fever",
    "Scarlet Fever",
    "Tuberculosis",
    "Whooping Cough",
    "Any Other",
  ];
  const conditions = [
    "ADHD",
    "Allergies",
    "Bronchiole Asthma",
    "Congenital Heart Disease",
    "Diabetes Mellitus",
    "Vision Difficulty",
    "Eczema",
    "Epilepsy/Seizure",
    "Febrile Convulsions",
    "Gastric disorders",
    "Hearing Difficulties",
    "Serious Accidents",
  ];
  const errorsObj = {
    center_id: false,
    captcha: false,
    child_name: false,
    // child_last_name: false,
    birth_date: false,
    joining_date: false,
    gender: false,
    country_id: false,
    father_name: false,
    father_mobile: false,
    father_email: false,
    mother_name: false,
    mother_email: false,
    mother_mobile: false,
  };

  // State
  const [locale, setLocale] = useState("en");
  const [countries, setCountries] = useState([]);
  // const [languages, setLanguages] = useState([]);
  // const [admissionAttachments, setAdmissionAttachments] = useState([]);
  const [errors, setErrors] = useState(errorsObj);
  const [step, setStep] = useState(1);
  const [stepName, setStepName] = useState("step.student_details");
  const [formSaving, setFormSaving] = useState(false);
  const [formData, setFormData] = useState({
    centerData: {
      center_id: "",
      center_uuid: "",
      logo: "",
    },

    childData: {
      admission_id: 0,
      child_id: 0,
      picture: "",
      child_name: "",
      birth_date: "",
      birth_city: "",
      joining_date: "",
      gender: "",
      country_id: "",
      id_number: "",
      passport_number: "",
      passport_validity: "",
      residency_number: "",
      residency_validity: "",
      child_school_attending: "",
      child_bloodgroup: "",
      child_sen: "No",

      allergies: "",
      allergic_reactions: "",
      medicines: "",

      child_medical_name: "",
      child_medical_doctor: "",
      child_medical_clinic: "",
      child_medical_phone: "",
      medical_note: "",
    },

    parentData: {
      parent_id: 0,
      sponsor_name: "",
      grandfather: "",
      phone1: "",
      email1: "",
      employer_father: "",
      position_id_father: "",
      parent_education_level: "",
      address: "",

      spouse_name: "",
      spouse_phone: "",
      spouse_email: "",
      employer_mother: "",
      position_id_mother: "",
      spouse_country: "",
      spouse_education_level: "",

      emergency_contact_name: "",
      emergency_contact_relation: "",
      emergency_phone1: "",
      emergency_phone2: "",
    },

    flags: {
      leela_allergies: "No",
      leela_dietry_intolerances: "No",
      leela_special_req: "No",
      check_acknowledgement: 1,
    },
  });

  const [health_declarations, setHealthDeclarations] = useState([]);
  const [picture, setPicture] = useState(null);

  const [admissionAttachmentModal, setAdmissionAttachmentModal] = useState({
    show: false,
    title: "",
    content: "",
  });

  const [chronicIllness, setChronicIllness] = useState("");
  const [chronicIllnessDesc, setChronicIllnessDesc] = useState("");
  const [chronicIllnessDate, setChronicIllnessDate] = useState("");

  const [illness, setIllness] = useState("");
  const [illnessDesc, setIllnessDesc] = useState("");
  const [illnessDate, setIllnessDate] = useState("");

  const [condition, setCondition] = useState("");
  const [conditionDesc, setConditionDesc] = useState("");
  const [conditionDate, setConditionDate] = useState("");
  const [doc, setDoc] = useState({
    father: {
      table_name: "parents",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
    mother: {
      table_name: "parents",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
    child: {
      table_name: "children",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
    other: {
      table_name: "children",
      table_id: "",
      type: "",
      desc: "",
      file: null,
    },
  });
  const [attachments, setAttachments] = useState({
    father: [],
    mother: [],
    child: [],
    other: [],
  });
  // On component load
  useEffect(() => {
    if (id) {
      getAdmissionData();
    }
  }, []);

  // Get admission data
  const getAdmissionData = async () => {
    try {
      const response = await fetch(`${API_URL}/get-data?id=${id}`, {
        method: "GET",
      });
      if (response.ok) {
        const responseData = await response.json();
        const {
          centerData,
          childData,
          childHealthData,
          countriesData,
          parentData,
          attachments,
        } = responseData.data;
        setAttachments(attachments);
        setCountries(countriesData);
        setFormData((prev) => ({
          ...prev,

          centerData: {
            ...prev.centerData,
            center_id: centerData.center_id,
            center_uuid: centerData.center_uuid,
            logo: centerData.logo,
          },

          childData: {
            ...prev.childData,
            child_id: childData.child_id,
            child_name: childData.child_name,
            picture: childData.picture,
            child_sen: childData.child_sen,
            birth_date: childData.birth_date,
            birth_city: childData.birth_city,
            joining_date: childData.joining_date,
            gender: childData.gender,
            country_id: childData.country_id,
            id_number: childData.id_number,
            passport_number: childData.passport_number,
            passport_validity: childData.passport_validity,
            residency_number: childData.residency_number,
            residency_validity: childData.residency_validity,
            child_school_attending: childData.child_school_attending,
            child_bloodgroup: childData.child_bloodgroup,
            medical_note: childData.medical_note,
            child_medical_name: childData.child_medical_name,
            child_medical_doctor: childData.child_medical_doctor,
            child_medical_clinic: childData.child_medical_clinic,
            child_medical_phone: childData.child_medical_phone,
          },

          parentData: {
            ...prev.parentData,
            parent_id: parentData.parent_id,
            // sponsor_role: parentData.sponsor_role ?? "Father",
            sponsor_name: parentData.sponsor_name,
            grandfather: parentData.grandfather,
            phone1: parentData.phone1,
            email1: parentData.email1,
            employer_father: parentData.employer_father,
            position_id_father: parentData.position_id_father,
            country_id: parentData.country_id,
            parent_education_level: parentData.parent_education_level,
            address: parentData.address,

            // spouse_role: parentData.spouse_role ?? "Mother",
            spouse_name: parentData.spouse_name,
            spouse_phone: parentData.spouse_phone,
            spouse_email: parentData.spouse_email,
            employer_mother: parentData.employer_mother,
            position_id_mother: parentData.position_id_mother,
            spouse_country: parentData.spouse_country,
            spouse_education_level: parentData.spouse_education_level,

            emergency_contact_name: parentData.emergency_contact_name,
            emergency_contact_relation: parentData.emergency_contact_relation,
            emergency_phone1: parentData.emergency_phone1,
          },
        }));

        // Health Declarations
        if (childHealthData.length > 0) {
          const healthDeclarations = [];
          childHealthData.map((item) => {
            healthDeclarations.push({
              ...item,
              uuid: chance.guid(),
            });
          });
          setHealthDeclarations(healthDeclarations);
        }

        // if (admission.picture) {
        //   setPicture({
        //     preview: `${PORTAL_URL + formData.center_uuid}/admissions_school/${
        //       admission.picture
        //     }`,
        //   });
        // }
      } else {
        console.log("NOT OK");
      }
    } catch (error) {
      console.log("Error!");
      console.log(error);
    }
  };

  // Handle language change
  const handleLanguageChange = (event) => {
    setLocale(event.target.value);
  };

  // Handle input change
  const handleChange = (e, section) => {
    const { name, value } = e.target;

    if (name.startsWith("child_use_toilet_")) {
      const index = parseInt(name.split("_")[3], 10);
      const child_use_toilet = [...formData.childData.child_use_toilet];
      child_use_toilet[index] = value;

      setFormData((prev) => ({
        ...prev,
        childData: {
          ...prev.childData,
          child_use_toilet,
        },
      }));
    } else if (section === "child") {
      setFormData((prev) => ({
        ...prev,
        childData: {
          ...prev.childData,
          [name]: value,
        },
      }));
    } else if (section === "parent") {
      setFormData((prev) => ({
        ...prev,
        parentData: {
          ...prev.parentData,
          [name]: value,
        },
      }));
    } else if (section === "center") {
      setFormData((prev) => ({
        ...prev,
        centerData: {
          ...prev.centerData,
          [name]: value,
        },
      }));
    } else {
      // default flat field
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Handle validation
  const validateStep = () => {
    let isValid = true;
    const errorsObj = {};

    if (step === 1) {
      const captchaValue = recaptcha.current?.getValue();

      if (!captchaValue) {
        errorsObj.captcha = true;
        isValid = false;
      }

      /* ---------- Center ---------- */
      if (!formData.centerData.center_id) {
        errorsObj.center_id = true;
        isValid = false;
      }

      /* ---------- Child ---------- */
      if (!formData.childData.child_name) {
        errorsObj.child_name = true;
        isValid = false;
      }

      if (!formData.childData.birth_date) {
        errorsObj.birth_date = true;
        isValid = false;
      }

      // if (!formData.childData.joining_date) {
      //   errorsObj.joining_date = true;
      //   isValid = false;
      // }

      if (!formData.childData.gender) {
        errorsObj.gender = true;
        isValid = false;
      }

      if (!formData.childData.country_id) {
        errorsObj.country_id = true;
        isValid = false;
      }

      /* ---------- Father ---------- */
      // if (!formData.parentData.spouse_name) {
      //   errorsObj.spouse_name = true;
      //   isValid = false;
      // }

      // if (!formData.parentData.father_mobile) {
      //   errorsObj.father_mobile = true;
      //   isValid = false;
      // }

      // if (!formData.parentData.father_email) {
      //   errorsObj.father_email = true;
      //   isValid = false;
      // }

      /* ---------- Mother ---------- */
      // if (!formData.parentData.mother_name) {
      //   errorsObj.mother_name = true;
      //   isValid = false;
      // }

      // if (!formData.parentData.mother_email) {
      //   errorsObj.mother_email = true;
      //   isValid = false;
      // }

      // if (!formData.parentData.mother_mobile) {
      //   errorsObj.mother_mobile = true;
      //   isValid = false;
      // }
    }

    setErrors(errorsObj);
    return isValid;
  };

  // Handle next step
  const handleNextStep = () => {
    handleSubmit(null);
  };

  // console.log(health_declarations);

  // const handlePrevStep = () => {
  //   setStep(step - 1);
  // };

  const handleSubmit = async (jumpStep) => {
    if (!validateStep()) {
      if (errorsObj.captcha) {
        toast.error(<FormattedMessage id="validation.captcha_required" />);
      } else {
        toast.warning(
          <FormattedMessage id="validation.fill_required_fields" />,
        );
      }
      return;
    }

    setFormSaving(true);

    try {
      const fD = new FormData();

      // 🔹 Clone nested formData
      const formDataObj = structuredClone(formData);

      // 🔹 Send full nested payload
      fD.append("formData", JSON.stringify(formDataObj));

      // 🔹 Image
      if (picture) {
        fD.append("picture", picture);
      }

      fD.append("step", step);

      // 🔹 Captcha (Step 1)
      if (step === 1) {
        const captchaValue = recaptcha.current?.getValue();
        fD.append("g-recaptcha-response", captchaValue);
      }

      fD.append(
        "health_declarations",
        JSON.stringify(
          health_declarations.map((h) => ({
            child_health_id: Number(h.child_health_id || 0),
            child_health_type: h.child_health_type,
            child_health_name: h.child_health_name,
            child_health_desc: h.child_health_desc,
            child_health_date: h.child_health_date
              ? moment(h.child_health_date).format("YYYY-MM-DD")
              : null,
          })),
        ),
      );

      // 🔹 Health Declarations (same as before)
      // health_declarations?.length > 0 &&
      //   health_declarations.forEach((h) => {
      //     fD.append(`health_declarations[${h.uuid}]`, h.uuid);
      //     fD.append(
      //       `health_declarations[child_health_id][${h.uuid}]`,
      //       h.child_health_id
      //     );
      //     fD.append(
      //       `health_declarations[child_health_name][${h.uuid}]`,
      //       h.child_health_name
      //     );
      //     fD.append(
      //       `health_declarations[child_health_desc][${h.uuid}]`,
      //       h.child_health_desc
      //     );
      //     fD.append(
      //       `health_declarations[child_health_date][${h.uuid}]`,
      //       moment(h.child_health_date).format("YYYY-MM-DD")
      //     );
      //     fD.append(
      //       `health_declarations[child_health_type][${h.uuid}]`,
      //       h.child_health_type
      //     );
      //   });

      const response = await fetch(`${API_URL}/update-data`, {
        method: "POST",
        body: fD,
      });

      if (response.ok) {
        const responseJson = await response.json();
        const { data, type, message } = responseJson;

        if (type) {
          const { centerData, childData, childHealthData, parentData } = data;

          console.log(
            "Response Data:",
            centerData,
            childData,
            childHealthData,
            parentData,
          );

          setFormData((prev) => ({
            ...prev,
            centerData: {
              ...prev.centerData,
              ...centerData,
            },
            childData: {
              ...prev.childData,
              ...childData,
            },
            parentData: {
              ...prev.parentData,
              ...parentData,
            },
          }));

          if (Array.isArray(childHealthData)) {
            const healthDeclarations = childHealthData.map((item) => ({
              ...item,
              uuid: chance.guid(),
            }));
            setHealthDeclarations(healthDeclarations);
          }

          // 🔹 Step handling (same as before)
          let stepNum = step;

          if (step < steps.length && !jumpStep) {
            stepNum = step + 1;
          } else if (jumpStep) {
            stepNum = jumpStep;
          }

          setStep(stepNum);
          setStepName(steps[stepNum - 1].name);

          toast.success(
            <FormattedMessage id="validation.saved_successfully" />,
          );
        } else {
          message && toast.info(message);
        }
      } else {
        console.log("Error submitting form");
      }

      // if (response.ok) {
      //   const { data, type, message } = await response.json();

      //   if (type) {
      //     const {centerData, childData, childHealthData, parentData } = data;

      //   console.log("Response Data:", centerData, childData, childHealthData, parentData);
      //     // 🔹 admission_id ab childData me store karo
      //     setFormData((prev) => ({
      //       ...prev,
      //       childData: {
      //         ...prev.childData,
      //       },
      //     }));

      //     // window.history.pushState(
      //     //   { id: admission_id },
      //     //   "",
      //     //   `?id=${admission_uuid}`
      //     // );

      //     let stepNum = step;

      //     if (step < steps.length && !jumpStep) {
      //       stepNum = step + 1;
      //     } else if (jumpStep) {
      //       stepNum = jumpStep;
      //     }

      //     setStep(stepNum);
      //     setStepName(steps[stepNum - 1].name);

      //     toast.success(
      //       <FormattedMessage id="validation.saved_successfully" />
      //     );
      //   } else {
      //     message && toast.info(message);
      //   }
      // } else {
      //   console.log("Error submitting form");
      // }
    } catch (error) {
      console.log("Something went wrong!", error);
    } finally {
      setFormSaving(false);
    }
  };

  // Handle Health Declaration Add
  const addHealthDeclaration = (child_health_type) => {
    const healthDeclaration = {
      child_health_name: "",
      child_health_desc: "",
      child_health_date: "",
    };

    if (child_health_type === "Chronic Illness") {
      if (!chronicIllness || !chronicIllnessDesc || !chronicIllnessDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_chronic_illness_fields" />,
        );
        return;
      }

      healthDeclaration.child_health_name = chronicIllness;
      healthDeclaration.child_health_desc = chronicIllnessDesc;
      healthDeclaration.child_health_date = chronicIllnessDate;
    } else if (child_health_type === "Illness") {
      if (!illness || !illnessDesc || !illnessDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_illness_fields" />,
        );
        return;
      }

      healthDeclaration.child_health_name = illness;
      healthDeclaration.child_health_desc = illnessDesc;
      healthDeclaration.child_health_date = illnessDate;
    } else if (child_health_type === "Condition") {
      if (!condition || !conditionDesc || !conditionDate) {
        toast.error(
          <FormattedMessage id="validation.fill_all_condition_fields" />,
        );
        return;
      }

      healthDeclaration.child_health_name = condition;
      healthDeclaration.child_health_desc = conditionDesc;
      healthDeclaration.child_health_date = conditionDate;
    }

    setHealthDeclarations((prevHealthDeclarations) => [
      ...prevHealthDeclarations,
      {
        child_health_id: 0,
        uuid: chance.guid(),
        child_health_type,
        ...healthDeclaration,
      },
    ]);

    if (child_health_type === "Chronic Illness") {
      setChronicIllness("");
      setChronicIllnessDesc("");
      setChronicIllnessDate("");
    } else if (child_health_type === "Illness") {
      setIllness("");
      setIllnessDesc("");
      setIllnessDate("");
    } else if (child_health_type === "Condition") {
      setCondition("");
      setConditionDesc("");
      setConditionDate("");
    }
  };
  // Handle Health Declaration Remove
  const removeHealthDeclaration = (uuid) => {
    setHealthDeclarations((prevHealthDeclarations) =>
      prevHealthDeclarations.filter(
        (healthDeclaration) => healthDeclaration.uuid !== uuid,
      ),
    );
  };

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <div id="page" dir={locale === "en" ? "ltr" : "rtl"}>
        <aside id="sidebar" className="d-none d-md-block position-relative">
          <small
            className="text-muted"
            style={{
              position: "absolute",
              bottom: 20,
              left: locale === "en" ? 20 : "auto",
              right: locale === "ar" ? 20 : "auto",
            }}
          >
            v{version}
          </small>
          <Row className="aside-header">
            <Col>
              <img
                src={formData.centerData.logo}
                alt="Educore"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ar"
                  variant={locale === "ar" ? "secondary" : "light"}
                >
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="steps-list">
            <ul>
              {steps.map((item, index) => (
                <li key={index} className={step === index + 1 ? "active" : ""}>
                  <Button
                    variant="link"
                    onClick={() => {
                      handleSubmit(index + 1);
                    }}
                  >
                    <FormattedMessage id={item.name} />
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </aside>
        <div id="content">
          <Row className="res-header d-md-none">
            <Col>
              <img
                src={formData.centerData.logo}
                alt="Educore"
                style={{ maxWidth: "100%", height: "150px" }}
              />
            </Col>
            <Col className="lang-switcher text-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="en"
                  variant={locale === "en" ? "secondary" : "light"}
                >
                  EN
                </Button>
                <Button
                  size="sm"
                  onClick={handleLanguageChange}
                  value="ar"
                  variant={locale === "ar" ? "secondary" : "light"}
                >
                  AR
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <div id="content_child" className="position-relative">
            <div className="form-nav">
              <Button
                variant={step === steps.length ? "success" : "primary"}
                onClick={handleNextStep}
                // disabled={
                //   formSaving || (step === steps.length)
                // }
              >
                <FormattedMessage
                  id={step === steps.length ? "submit" : "next"}
                />
              </Button>
            </div>
            <h2 className="mb-3">
              <FormattedMessage id={stepName} />
            </h2>

            {/* STEP 1 */}
            {step === 1 && (
              <>
                <Row alignItems={"center"}>
                  <Col md={6} lg={3} xl={4} xxl={2}>
                    {/* <FilePicker
                      name="picture"
                      file={picture}
                      setFile={setPicture}
                      height={200}
                    /> */}
                    <div
                      className="d-flex justify-content-center align-items-center mb-2"
                      style={{ height: 150 }}
                    >
                      <img
                        src={`${STORAGE_URL}${formData.centerData.center_uuid}/admission_school/${formData.childData.picture}`}
                        alt=""
                        className="img-fluid"
                        style={{
                          maxHeight: 140,
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </Col>
                  <Col
                    md={6}
                    lg={3}
                    xxl={2}
                    className="d-flex align-items-center"
                  >
                    {/* <FormattedMessage id="child_picture" /> */}
                  </Col>

                  {/* <Col md={12} xl={6} className="mt-5 lg:mt-3">
                    <CenterDropdown
                      onSelectCenter={handleCenterSelect}
                      isEditMode={formData?.admission_id ? true : false}
                      selectedCenterId={formData?.center_id}
                      error={errors?.center_id}
                    /> 
                  </Col>*/}

                  <Col
                    md={12}
                    xl={8}
                    className="ml-lg-auto d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-end gap-5 flex-column-reverse mt-5 lg:mt-3"
                  >
                    <ReCAPTCHA
                      ref={recaptcha}
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    />
                  </Col>
                </Row>

                {/* Child Details */}
                <SectionSeparator title="title.child_details" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="child_first_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.childData.child_name}
                            placeholder={placeholder}
                            type="text"
                            name="child_name"
                            onChange={(e) => handleChange(e, "child")}
                            isInvalid={!!errors.child_name}
                            disabled={true}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.child_name" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="birth_date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.birth_date
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.childData.birth_date}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                childData: {
                                  ...prevData.childData,
                                  birth_date: date,
                                },
                              }))
                            }
                            dateFormat="dd/MM/yyyy"
                            disabled={true}
                          />
                        )}
                      </FormattedMessage>
                      <div
                        className={errors.birth_date ? "is-invalid" : ""}
                      ></div>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.birth_date" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="birth_city">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.childData.birth_city}
                            placeholder={placeholder}
                            type="text"
                            name="birth_city"
                            onChange={(e) => handleChange(e, "child")}
                            // isInvalid={!!errors.birth_city}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.birth_city" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        name="gender"
                        onChange={(e) => handleChange(e, "child")}
                        value={formData.childData.gender}
                        isInvalid={!!errors.gender}
                      >
                        <option value="">
                          <FormattedMessage id="select_gender" />
                        </option>
                        <option value="F">
                          <FormattedMessage id="female" />
                        </option>
                        <option value="M">
                          <FormattedMessage id="male" />
                        </option>
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.gender" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <Form.Select
                        onChange={(e) => handleChange(e, "child")}
                        name="country_id"
                        value={formData.childData.country_id}
                        isInvalid={!!errors.country_id}
                        disabled={true}
                      >
                        <option value="">
                          <FormattedMessage id="select_nationality" />
                        </option>
                        {countries?.map((country, index) => (
                          <option key={index} value={country.country_id}>
                            {country.country_name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.country_id" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <span className="required-field">*</span>
                      <FormattedMessage id="id_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.childData.id_number}
                            placeholder={placeholder}
                            type="text"
                            name="id_number"
                            onChange={(e) => handleChange(e, "child")}
                            isInvalid={!!errors.id_number}
                          />
                        )}
                      </FormattedMessage>
                      <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.id_number" />
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_num">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.childData.passport_number}
                            placeholder={placeholder}
                            type="text"
                            name="passport_number"
                            onChange={(e) => handleChange(e, "child")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="passport_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors?.passport_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.childData.passport_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                childData: {
                                  ...prevData.childData,
                                  passport_validity: date,
                                },
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.childData.residency_number}
                            placeholder={placeholder}
                            type="text"
                            name="residency_number"
                            onChange={(e) => handleChange(e, "child")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="residency_validity">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={
                              errors.residency_validity
                                ? " form-control is-invalid"
                                : "form-control"
                            }
                            selected={formData.childData.residency_validity}
                            onChange={(date) =>
                              setFormData((prevData) => ({
                                ...prevData,
                                childData: {
                                  ...prevData.childData,
                                  residency_validity: date,
                                },
                              }))
                            }
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Family Details */}
                <SectionSeparator title="title.family_details" />
                <SubSectionSeparator title="title.sponsor_parent_information" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="full_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.sponsor_name}
                            placeholder={placeholder}
                            type="text"
                            name="sponsor_name"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.sponsor_name}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="email_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.email1}
                            placeholder={placeholder}
                            type="text"
                            name="email1"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.email1}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.email" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="mobile_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.phone1}
                            placeholder={placeholder}
                            type="text"
                            name="phone1"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.phone1}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.mobile" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="home_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.address}
                            placeholder={placeholder}
                            type="text"
                            name="address"
                            onChange={(e) => handleChange(e, "parent")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="home_phone">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.home_phone}
                            placeholder={placeholder}
                            type="text"
                            name="home_phone"
                            onChange={(e) => handleChange(e, "parent")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col> */}

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="education">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.parent_education_level}
                            placeholder={placeholder}
                            type="text"
                            name="parent_education_level"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.parent_education_level}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="place_of_work">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.employer_father}
                            placeholder={placeholder}
                            type="text"
                            name="employer_father"
                            onChange={(e) => handleChange(e, "parent")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="occupation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.position_id_father}
                            placeholder={placeholder}
                            type="text"
                            name="position_id_father"
                            onChange={(e) => handleChange(e, "parent")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="grandfather_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.grandfather}
                            placeholder={placeholder}
                            type="text"
                            name="grandfather"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.grandfather}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                </Row>

                <SubSectionSeparator title="title.spouse_information" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="full_name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.spouse_name}
                            placeholder={placeholder}
                            type="text"
                            name="spouse_name"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.spouse_name}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.full_name" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="email_address">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.spouse_email}
                            placeholder={placeholder}
                            type="text"
                            name="spouse_email"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.spouse_email}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.email" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="mobile_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.spouse_phone}
                            placeholder={placeholder}
                            type="text"
                            name="spouse_phone"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.spouse_phone}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.mobile" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <Form.Select
                        onChange={(e) => handleChange(e, "parent")}
                        name="spouse_country"
                        value={formData.parentData.spouse_country}
                        isInvalid={!!errors.spouse_country}
                      >
                        <option value="">
                          <FormattedMessage id="select_nationality" />
                        </option>
                        {countries?.map((country, index) => (
                          <option
                            key={index}
                            value={country.mother_nationality}
                          >
                            {country.country_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      <FormattedMessage id="education">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.spouse_education_level}
                            placeholder={placeholder}
                            type="text"
                            name="spouse_education_level"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.spouse_education_level}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="place_of_work">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.employer_mother}
                            placeholder={placeholder}
                            type="text"
                            name="employer_mother"
                            onChange={(e) => handleChange(e, "parent")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="occupation">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.position_id_mother}
                            placeholder={placeholder}
                            type="text"
                            name="position_id_mother"
                            onChange={(e) => handleChange(e, "parent")}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                </Row>

                <SectionSeparator title="title.emergency_contact" />
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="name">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.emergency_contact_name}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_contact_name"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.emergency_contact_name}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_name" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="relation">
                        {(placeholder) => (
                          <Form.Control
                            value={
                              formData.parentData.emergency_contact_relation
                            }
                            placeholder={placeholder}
                            type="text"
                            name="emergency_contact_relation"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.emergency_contact_relation}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_relation" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <FormattedMessage id="contact_number">
                        {(placeholder) => (
                          <Form.Control
                            value={formData.parentData.emergency_phone1}
                            placeholder={placeholder}
                            type="text"
                            name="emergency_phone1"
                            onChange={(e) => handleChange(e, "parent")}
                            isInvalid={!!errors.emergency_phone1}
                          />
                        )}
                      </FormattedMessage>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                        <FormattedMessage id="error.emergency_contact_number" />
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {/* STEP 2 */}
            {step === 2 && (
              <>
                {/* Child's Documents */}
                <SectionSeparator title="title.child_documents" />
                <DocumentUploadBlock
                  options={DOCUMENT_TYPES.child}
                  value={doc.child.type}
                  description={doc.child.desc}
                  center_id={formData.centerData.center_id}
                  center_uuid={formData.centerData.center_uuid}
                  tableName="children"
                  tableId={formData.childData.child_id}
                  attachments={attachments.child}
                  setAttachments={(files) =>
                    setAttachments((prev) => ({
                      ...prev,
                      child: files,
                    }))
                  }
                  file={doc.child.file}
                  setFile={(file) =>
                    setDoc((prev) => ({
                      ...prev,
                      child: { ...prev.child, file },
                    }))
                  }
                  onTypeChange={(e) =>
                    setDoc((prev) => ({
                      ...prev,
                      child: { ...prev.child, type: e.target.value },
                    }))
                  }
                  onDescChange={(e) =>
                    setDoc((prev) => ({
                      ...prev,
                      child: { ...prev.child, desc: e.target.value },
                    }))
                  }
                />

                {/* Sponsor's Documents */}
                <SectionSeparator title="title.sponsor_documents" />
                <DocumentUploadBlock
                  options={DOCUMENT_TYPES.father}
                  value={doc.father.type}
                  description={doc.father.desc}
                  center_id={formData.centerData.center_id}
                  center_uuid={formData.centerData.center_uuid}
                  tableName="parents"
                  tableId={formData.parentData.parent_id}
                  attachments={attachments.father}
                  setAttachments={(files) =>
                    setAttachments((prev) => ({
                      ...prev,
                      father: files,
                    }))
                  }
                  file={doc.father.file}
                  setFile={(file) =>
                    setDoc((prev) => ({
                      ...prev,
                      father: { ...prev.father, file },
                    }))
                  }
                  onTypeChange={(e) =>
                    setDoc((prev) => ({
                      ...prev,
                      father: { ...prev.father, type: e.target.value },
                    }))
                  }
                  onDescChange={(e) =>
                    setDoc((prev) => ({
                      ...prev,
                      father: { ...prev.father, desc: e.target.value },
                    }))
                  }
                />

                {/* Spouse's Documents */}
                <SectionSeparator title="title.spouse_documents" />
                <DocumentUploadBlock
                  options={DOCUMENT_TYPES.mother}
                  value={doc.mother.type}
                  description={doc.mother.desc}
                  center_id={formData.centerData.center_id}
                  center_uuid={formData.centerData.center_uuid}
                  tableName="parents"
                  tableId={formData.parentData.parent_id}
                  attachments={attachments.mother}
                  setAttachments={(files) =>
                    setAttachments((prev) => ({
                      ...prev,
                      mother: files,
                    }))
                  }
                  file={doc.mother.file}
                  setFile={(file) =>
                    setDoc((prev) => ({
                      ...prev,
                      mother: { ...prev.mother, file },
                    }))
                  }
                  onTypeChange={(e) =>
                    setDoc((prev) => ({
                      ...prev,
                      mother: { ...prev.mother, type: e.target.value },
                    }))
                  }
                  onDescChange={(e) =>
                    setDoc((prev) => ({
                      ...prev,
                      mother: { ...prev.mother, desc: e.target.value },
                    }))
                  }
                />
              </>
            )}

            {step === 3 && (
              <>
                <SectionSeparator title="title.medical_information" />
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="medical_emergency_name" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="child_medical_name"
                        value={formData.childData.child_medical_name}
                        onChange={(e) => handleChange(e, "child")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="medical_emergency_doc" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="child_medical_doctor"
                        value={formData.childData.child_medical_doctor}
                        onChange={(e) => handleChange(e, "child")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="medical_emergency_clinic" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="child_medical_clinic"
                        value={formData.childData.child_medical_clinic}
                        onChange={(e) => handleChange(e, "child")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="medical_emergency_phone" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="child_medical_phone"
                        value={formData.childData.child_medical_phone}
                        onChange={(e) => handleChange(e, "child")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <FormattedMessage id="bloodgroup" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="child_bloodgroup"
                        value={formData.childData.child_bloodgroup}
                        onChange={(e) => handleChange(e, "child")}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4 position-relative">
                      {/* <span className="required-field">*</span> */}
                      <Form.Label>
                        <FormattedMessage id="child_sen" />
                      </Form.Label>
                      <Form.Select
                        onChange={(e) => handleChange(e, "child")}
                        name="child_sen"
                        value={formData.childData.child_sen}
                        isInvalid={!!errors.child_sen}
                      >
                        <option value="">
                          <FormattedMessage id="child_sen" />
                        </option>
                        <option value={1}>
                          <FormattedMessage id="yes" />
                        </option>
                        <option value={0}>
                          <FormattedMessage id="no" />
                        </option>
                      </Form.Select>
                      {/* <Form.Control.Feedback className="px-3" type="invalid">
                                          <FormattedMessage id="error.child_sen" />
                                        </Form.Control.Feedback> */}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="notes" />
                      </Form.Label>
                      <Form.Control
                        value={formData.childData.medical_note}
                        type="text"
                        name="medical_note"
                        onChange={(e) => handleChange(e, "child")}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Chronic Illnesses */}
                <SectionSeparator title="title.health_declaration_form" />
                <Row>
                  <Col md={12}>
                    {" "}
                    <Form.Label>
                      <FormattedMessage id="chronic_illness" />
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={(e) => setChronicIllness(e.target.value)}
                        value={chronicIllness}
                      >
                        <option value="">
                          <FormattedMessage id="select" />
                        </option>
                        {chronicIllnesses.map((illness, index) => (
                          <option key={index} value={illness}>
                            {illness}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <FormattedMessage id="info_treatments_medications">
                      {(placeholder) => (
                        <Form.Control
                          value={chronicIllnessDesc}
                          placeholder={placeholder}
                          type="text"
                          onChange={(e) =>
                            setChronicIllnessDesc(e.target.value)
                          }
                        />
                      )}
                    </FormattedMessage>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={"form-control"}
                            selected={chronicIllnessDate}
                            onChange={(date) => setChronicIllnessDate(date)}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={1} className="ps-4">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => addHealthDeclaration("Chronic Illness")}
                    >
                      <FiPlus />
                    </Button>
                  </Col>
                </Row>
                {health_declarations
                  .filter(
                    (healthDeclaration) =>
                      healthDeclaration.child_health_type === "Chronic Illness",
                  )
                  .map((healthDeclaration, index) => (
                    <Row key={index} className="mb-3">
                      <Col md={3} className="ps-4">
                        {healthDeclaration.child_health_name}
                      </Col>
                      <Col md={5} className="ps-4">
                        {healthDeclaration.child_health_desc}
                      </Col>
                      <Col md={3} className="ps-4">
                        {moment(healthDeclaration.child_health_date).format(
                          "DD/MM/YYYY",
                        )}
                      </Col>
                      <Col md={1} className="ps-4">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            removeHealthDeclaration(healthDeclaration.uuid)
                          }
                        >
                          <FiMinus />
                        </Button>
                      </Col>
                    </Row>
                  ))}

                <hr />

                {/* Illnesses */}
                <Row>
                  <Col md={12}>
                    {" "}
                    <Form.Label>
                      <FormattedMessage id="child_illness" />
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={(e) => setIllness(e.target.value)}
                        value={illness}
                      >
                        <option value="">
                          <FormattedMessage id="select" />
                        </option>
                        {illnesses.map((illness, index) => (
                          <option key={index} value={illness}>
                            {illness}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <FormattedMessage id="info_treatments_medications">
                      {(placeholder) => (
                        <Form.Control
                          value={illnessDesc}
                          placeholder={placeholder}
                          type="text"
                          onChange={(e) => setIllnessDesc(e.target.value)}
                        />
                      )}
                    </FormattedMessage>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={"form-control"}
                            selected={illnessDate}
                            onChange={(date) => setIllnessDate(date)}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={1} className="ps-4">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => addHealthDeclaration("Illness")}
                    >
                      <FiPlus />
                    </Button>
                  </Col>
                </Row>
                {health_declarations
                  .filter(
                    (healthDeclaration) =>
                      healthDeclaration.child_health_type === "Illness",
                  )
                  .map((healthDeclaration, index) => (
                    <Row key={index} className="mb-3">
                      <Col md={3} className="ps-4">
                        {healthDeclaration.child_health_name}
                      </Col>
                      <Col md={5} className="ps-4">
                        {healthDeclaration.child_health_desc}
                      </Col>
                      <Col md={3} className="ps-4">
                        {moment(healthDeclaration.child_health_date).format(
                          "DD/MM/YYYY",
                        )}
                      </Col>
                      <Col md={1} className="ps-4">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            removeHealthDeclaration(healthDeclaration.uuid)
                          }
                        >
                          <FiMinus />
                        </Button>
                      </Col>
                    </Row>
                  ))}

                <hr />

                {/* Condition */}
                <Row>
                  <Col md={12}>
                    {" "}
                    <Form.Label>
                      <FormattedMessage id="child_conditions" />
                    </Form.Label>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <Form.Select
                        onChange={(e) => setCondition(e.target.value)}
                        value={condition}
                      >
                        <option value="">
                          <FormattedMessage id="select" />
                        </option>
                        {conditions.map((condition, index) => (
                          <option key={index} value={condition}>
                            {condition}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <FormattedMessage id="info_treatments_medications">
                      {(placeholder) => (
                        <Form.Control
                          value={conditionDesc}
                          placeholder={placeholder}
                          type="text"
                          onChange={(e) => setConditionDesc(e.target.value)}
                        />
                      )}
                    </FormattedMessage>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-4">
                      <FormattedMessage id="date">
                        {(placeholder) => (
                          <DatePicker
                            placeholderText={placeholder}
                            className={"form-control"}
                            selected={conditionDate}
                            onChange={(date) => setConditionDate(date)}
                          />
                        )}
                      </FormattedMessage>
                    </Form.Group>
                  </Col>
                  <Col md={1} className="ps-4">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => addHealthDeclaration("Condition")}
                    >
                      <FiPlus />
                    </Button>
                  </Col>
                </Row>
                {health_declarations
                  .filter(
                    (healthDeclaration) =>
                      healthDeclaration.child_health_type === "Condition",
                  )
                  .map((healthDeclaration, index) => (
                    <Row key={index} className="mb-3">
                      <Col md={3} className="ps-4">
                        {healthDeclaration.child_health_name}
                      </Col>
                      <Col md={5} className="ps-4">
                        {healthDeclaration.child_health_desc}
                      </Col>
                      <Col md={3} className="ps-4">
                        {moment(healthDeclaration.child_health_date).format(
                          "DD/MM/YYYY",
                        )}
                      </Col>
                      <Col md={1} className="ps-4">
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() =>
                            removeHealthDeclaration(healthDeclaration.uuid)
                          }
                        >
                          <FiMinus />
                        </Button>
                      </Col>
                    </Row>
                  ))}
              </>
            )}

            {/* STEP 3 */}
            {/* {step === 3 && (
            <>
              {admissionAttachments.length > 0 && (
                <>
                  <SectionSeparator title="title.settling_in_policy" />
                  <ul>
                    {admissionAttachments.map((attachment, index) => (
                      <li key={index}>
                        <Button
                          onClick={() =>
                            setAdmissionAttachmentModal({
                              show: true,
                              title: attachment.title,
                              content: attachment.text,
                            })
                          }
                          variant="link"
                        >
                          {attachment.title}
                        </Button>
                      </li>
                    ))}
                  </ul>
                </>
              )}
              <SectionSeparator title="title.acknowledgement" />
              <Row className="mb-4">
                <Col md={"auto"}>
                  <Form.Check
                    checked={acknowledgement}
                    onChange={(e) => setAcknowledgement(!acknowledgement)}
                    type="checkbox"
                  />
                </Col>
                <Col>
                  <FormattedMessage id="acknowledgement" />
                </Col>
              </Row>
            </>
          )} */}
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        show={admissionAttachmentModal.show}
        onHide={() =>
          setAdmissionAttachmentModal({
            show: false,
            title: "",
            content: "",
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>{admissionAttachmentModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            dangerouslySetInnerHTML={{
              __html: admissionAttachmentModal.content,
            }}
          />
        </Modal.Body>
      </Modal>
      <ToastContainer
        position={locale === "en" ? "bottom-right" : "bottom-left"}
        rtl={locale === "ar"}
        hideProgressBar={true}
        theme="colored"
      />
    </IntlProvider>
  );
};

export default App;
